import React from 'react';
import { getSiteCssVariables } from '@wix/tpa-style-webpack-plugin/standalone';
import { SITE_COLORS, SITE_TEXT_PRESETS } from './theme';
import { TPAComponentsProvider } from '@wix/wix-ui-tpa/cssVars';
export const StyleProvider = _ref => {
  let {
    children
  } = _ref;
  const siteCssVariables = getSiteCssVariables(SITE_COLORS, SITE_TEXT_PRESETS);
  return /*#__PURE__*/React.createElement("div", {
    style: siteCssVariables.variables
  }, /*#__PURE__*/React.createElement(TPAComponentsProvider, {
    value: {}
  }, children));
};
//# sourceMappingURL=style-provider.js.map